export const TOKEN_STORAGE_KEY = 'token';
export const SUPERADMIN_TOKEN_STORAGE_KEY = 'superadmin_token';
export const SCHOOL_ID_KEY = 'schoolId';
export const USER_DATA_KEY = 'userData';
export const USER_KEY = 'user';
export const REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';
export const SUPERADMIN_REMEMBER_ME_KEY = 'superadmin_remember_me';

export const getToken = () => {
  const raw = localStorage.getItem(TOKEN_STORAGE_KEY) || sessionStorage.getItem(TOKEN_STORAGE_KEY);
  if (!raw || raw === 'null' || raw === 'undefined' || !raw.trim()) return null;
  return raw.replace(/[\r\n\s]/g, '').trim();
};

export const setToken = (value, rememberMe) => {
  if (rememberMe) {
    localStorage.setItem(TOKEN_STORAGE_KEY, value);
    sessionStorage.removeItem(TOKEN_STORAGE_KEY);
  } else {
    sessionStorage.setItem(TOKEN_STORAGE_KEY, value);
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  }
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  sessionStorage.removeItem(TOKEN_STORAGE_KEY);
};

export const getSuperadminToken = () => localStorage.getItem(SUPERADMIN_TOKEN_STORAGE_KEY);
export const setSuperadminToken = (value) => localStorage.setItem(SUPERADMIN_TOKEN_STORAGE_KEY, value);
export const clearSuperadminToken = () => localStorage.removeItem(SUPERADMIN_TOKEN_STORAGE_KEY);

export const getSuperadminRememberMe = () => localStorage.getItem(SUPERADMIN_REMEMBER_ME_KEY) === 'true';
export const setSuperadminRememberMe = (val) => localStorage.setItem(SUPERADMIN_REMEMBER_ME_KEY, String(val));
export const clearSuperadminRememberMe = () => localStorage.removeItem(SUPERADMIN_REMEMBER_ME_KEY);
export const getTokenRememberMe = () => localStorage.getItem(TOKEN_STORAGE_KEY) !== null;

export const getSchoolId = () => localStorage.getItem(SCHOOL_ID_KEY);
export const setSchoolId = (value) => localStorage.setItem(SCHOOL_ID_KEY, value);

export const getUserData = () => localStorage.getItem(USER_DATA_KEY) || sessionStorage.getItem(USER_DATA_KEY) || null;
export const getUser = () => localStorage.getItem(USER_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);

// ── Cache géométrie des circuits (Directions API) ───────────────────────────
// Persiste le tracé routier calculé d'un circuit pour éviter de rappeler la
// Mapbox Directions API à chaque montage de carte / bascule de sens.
// 1 entrée par circuit ; invalidation par hash des waypoints (auto-recalcul si
// les arrêts ou l'ordre changent).
export const CIRCUIT_ROUTE_KEY_PREFIX = 'circuitRoute:';

export const getCircuitRouteCache = (circuitId) => {
  try {
    const raw = localStorage.getItem(`${CIRCUIT_ROUTE_KEY_PREFIX}${circuitId}`);
    return raw ? JSON.parse(raw) : null; // { hash, data }
  } catch {
    return null;
  }
};

export const setCircuitRouteCache = (circuitId, hash, data) => {
  try {
    localStorage.setItem(`${CIRCUIT_ROUTE_KEY_PREFIX}${circuitId}`, JSON.stringify({ hash, data }));
  } catch {
    /* quota dépassé / mode privé → on ignore, le cache mémoire prend le relais */
  }
};
